<template>
    <div class="header-contaioner">
      <div class="user-info" >
        <img src="../../../assets/ben-unsplash.jpg"
           alt=""
           class="avatar">
        <div>
          <p class="user-name" v-if="user_info.recipient_name">{{ user_info.recipient_name }}</p>
          <p class="phone-number">{{ user_info.recipient_number }}</p>
        </div>
      </div>   
      <div class="user-info">
        <svg class="svg-gray"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1">
          <path d="M23.4529887,20.2646064 L20.7068672,17.504945 C20.3380768,17.1363901 19.8442339,16.9333217 19.3165145,16.9333217 C18.7673374,16.9333217 18.2488142,17.1505228 17.8567582,17.5445796 L16.7878002,18.6181103 C15.9571571,18.1543375 14.8531436,17.5164722 13.706922,16.3650934 C12.5620366,15.2146621 11.9269499,14.1089184 11.4628964,13.2700376 L12.5328761,12.1960332 C13.3283852,11.3952869 13.3446553,10.1106346 12.5692678,9.332469 L9.82369655,6.57446561 C9.45592787,6.20401582 8.96208503,6 8.43302945,6 C7.89611389,6 7.38820168,6.20764768 6.99842503,6.58559805 C6.76262549,6.77634969 5.57930479,7.8256416 5.13828104,9.98959892 C4.52080064,13.0184917 5.93952789,15.9327441 10.0352087,20.0485107 C14.6104273,24.6428934 18.5162895,25 19.6044258,25 C19.8309505,25 19.9676357,24.9859463 20.004106,24.9816828 C22.1378561,24.7304528 22.9018466,23.7785895 23.4596697,23.0835619 C24.1824739,22.1827815 24.1799587,20.9975317 23.4529887,20.2646064 Z M22.5417807,22.3402148 C22.0174411,22.9934759 21.5222621,23.6104185 19.8669493,23.8053547 C19.8660847,23.8054337 19.7755377,23.8156187 19.6044258,23.8156187 C18.6308881,23.8156187 15.1236057,23.4835403 10.8689173,19.211051 C7.09195885,15.4155198 5.76629382,12.81266 6.2933058,10.227091 C6.67797346,8.33962884 7.69922128,7.5373824 7.7389142,7.50690635 L7.77412693,7.48077275 L7.80501667,7.44966507 C7.97549974,7.27857285 8.19848751,7.18430238 8.43295085,7.18430238 C8.64642804,7.18430238 8.84387086,7.26467704 8.98943777,7.41137263 L11.7356378,10.1700076 C12.0516092,10.4870849 12.0347889,11.0206526 11.6986173,11.3590472 L10.4885727,12.5735099 L10.4686869,12.5944325 C10.1533443,12.943328 10.1904434,13.4148383 10.3641491,13.7218884 C10.8653803,14.6304852 11.55195,15.8748712 12.8730562,17.2023162 C14.1897609,18.5249451 15.4267653,19.2140512 16.3287771,19.7165902 C16.4190884,19.7675152 16.6055272,19.8529429 16.8388901,19.8529429 C17.1144612,19.8529429 17.3674741,19.7357759 17.5547776,19.5222067 L18.6903882,18.3818025 C18.859928,18.2114208 19.0822084,18.1175451 19.3163573,18.1175451 C19.5303061,18.1175451 19.7287707,18.1981566 19.8740233,18.3432732 L22.6183369,21.1011186 C22.9669273,21.4525406 22.8230109,21.9898192 22.5417807,22.3402148 Z M16.5107358,8.90161979 C16.1872188,8.86419584 15.9552707,8.57048885 15.992527,8.24567418 C16.0297833,7.92085951 16.3222533,7.68747299 16.6455345,7.72513381 C17.925926,7.8731716 19.3579367,8.60467571 20.3828787,9.6343082 C21.4174885,10.673652 22.1475238,12.1269489 22.2879818,13.4270761 C22.3231159,13.7522065 22.0892028,14.0443345 21.7655286,14.0796267 C21.7439922,14.0819163 21.7224559,14.0831006 21.7012339,14.0831006 C21.4041265,14.0831006 21.148677,13.8582411 21.1159009,13.5548228 C21.0048393,12.5262957 20.3897955,11.3160965 19.5491701,10.4716889 C18.7163261,9.63501878 17.523652,9.01870782 16.5107358,8.90161979 Z M15.9599867,11.3821806 C15.6365483,11.3447567 15.4045215,11.0509707 15.4416993,10.7260771 C15.4789556,10.4012624 15.7710326,10.1677969 16.0947854,10.2056157 C17.0298878,10.3138609 18.0249618,10.9413043 18.5962255,11.5152172 C19.1726768,12.0942622 19.8002966,13.1036826 19.9027908,14.0533352 C19.9379249,14.3784656 19.7039332,14.6705936 19.380259,14.7058858 C19.3587227,14.7081754 19.3372649,14.7093597 19.3160429,14.7093597 C19.0189355,14.7093597 18.763486,14.4845002 18.7307099,14.181003 C18.6707382,13.6247756 18.263591,12.8559265 17.7626742,12.3526769 C17.2660017,11.8537698 16.5078276,11.4455803 15.9599867,11.3821806 Z"
                id="path-1">
          </path>
        </svg>
        <svg class="svg-gray"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1">
          <path d="M10,16 C9.44771525,16 9,15.5522847 9,15 C9,14.4477153 9.44771525,14 10,14 C10.5522847,14 11,14.4477153 11,15 C11,15.5522847 10.5522847,16 10,16 Z M15,16 C14.4477153,16 14,15.5522847 14,15 C14,14.4477153 14.4477153,14 15,14 C15.5522847,14 16,14.4477153 16,15 C16,15.5522847 15.5522847,16 15,16 Z M20,16 C19.4477153,16 19,15.5522847 19,15 C19,14.4477153 19.4477153,14 20,14 C20.5522847,14 21,14.4477153 21,15 C21,15.5522847 20.5522847,16 20,16 Z"
                id="path-1">
          </path>
        </svg>
      </div>
    </div>
</template>

<script>
export default {
  components: {},
  props: ['user_info'],
  data: () => ({}),
  created() {
    console.log("user_info", this.user_info)
  }
}
</script>

<style lang="scss" scoped>
.header-contaioner {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .user-info {
        display: flex;
        align-items: center;
    p {
        color: #55616e;
        margin-bottom: 0;
        font-size: 16px;
    }
    .user-name {
        color: #000000;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        margin-bottom: 0;
    }
    .phone-number {
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        margin-bottom: 0;
    }
    .svg-gray {
        cursor: pointer;
        margin-left: 15px;
        fill: #55616e;
    }
  }
}
</style>